
export const stateReducer = (state, action) => {
    // console.log(action.type);
    // console.log(JSON.stringify(action));
    // console.log(`state:\n${JSON.stringify(state, null, 2)}`);
    // console.log(`action: ${JSON.stringify(action)} `);
    let currentLog = state.log;

    switch (action.type) {

        case 'appendLog':

            currentLog.push(action.newMsg);

            return {
                ...state, log: currentLog
            };

        case 'connect':

            // currentLog.push('connecting to: ' + action.target);

            return {
                ...state,
                log: ['connecting to: ' + action.target, 'listTables()'],
                operation: {target:null, action: null},
                connection: action.target,
                metadata:[]
            };

        case 'clearLog':
            return {
                ...state, log: []
            };

        case 'setOperation':
            return {
                ...state, operation: action.operation
            };

        case 'setMetadata':
            return {
                ...state, metadata: action.metadata
            };

        default:
            return state;
    }
};
